import { render, staticRenderFns } from "./colorForm.vue?vue&type=template&id=57ae7f32&scoped=true&"
import script from "./colorForm.vue?vue&type=script&lang=js&"
export * from "./colorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ae7f32",
  null
  
)

export default component.exports